export function isEventRecord(engagement) {
    if (!engagement || typeof engagement !== 'object') return false;
    if (String(engagement.service_type || '').trim().toLowerCase() === 'event') return true;
    const details = engagement.event_engagement_details;
    return Array.isArray(details)
        ? details.length > 0
        : Boolean(details && typeof details === 'object' && (details.id || details.engagement_id));
}

export function excludeEventRecords(engagements) {
    return (Array.isArray(engagements) ? engagements : []).filter((engagement) => !isEventRecord(engagement));
}
